module.exports = "<div *ngIf=\"loaders.hasOwnProperty(loaderName) && loaders[loaderName].status\" class=\"preloader\">\n    <div class=\"text-center\">Loading . . .</div>\n    <div class=\"sk-folding-cube\">\n        <div class=\"sk-cube1 sk-cube\"></div>\n        <div class=\"sk-cube2 sk-cube\"></div>\n        <div class=\"sk-cube4 sk-cube\"></div>\n        <div class=\"sk-cube3 sk-cube\"></div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/core/loader/loader.component.html
// module id = ../../../../../src/app/core/loader/loader.component.html
// module chunks = 1